import React, { useState } from 'react';
import { isCampaignActive, currencyLabel } from './clientUtils';
import { NEUTRAL, STATUS_COLORS } from './designTokens';

const EMPTY_FORM = {
  title: '', description: '', duration: 60, price: '', currency: 'SEK', is_active: true,
  campaign_enabled: false, campaign_label: '', campaign_price: '', campaign_start_date: '', campaign_end_date: '',
};

function getCampaignStatus(s) {
  if (!s.campaign_enabled) return null;
  if (isCampaignActive(s)) return 'active';
  const today = new Date().toISOString().slice(0, 10);
  if (s.campaign_start_date && s.campaign_start_date > today) return 'upcoming';
  return 'expired';
}

function ServiceForm({ theme, form, onChange, onSubmit, onCancel, saving, heading, submitLabel }) {
  return (
    <form onSubmit={onSubmit} style={{ border: `1px solid ${theme.card_border}`, borderRadius: theme.card_radius, padding: '18px', marginBottom: '18px', background: theme.card_bg }}>
      <p style={{ margin: '0 0 14px', fontWeight: 600, color: NEUTRAL.text }}>{heading}</p>

      <div style={{ marginBottom: '12px' }}>
        <label style={{ display: 'block', fontSize: '0.85em', color: theme.text_secondary, marginBottom: '4px' }}>Namn *</label>
        <input
          name="title"
          value={form.title}
          onChange={onChange}
          placeholder='t.ex. "Massage 60 min"'
          required
          autoFocus
          style={{ width: '100%', padding: '7px 10px', border: `1px solid ${theme.card_border}`, borderRadius: theme.btn_radius, fontSize: '0.95em', boxSizing: 'border-box' }}
        />
      </div>

      <div style={{ marginBottom: '12px' }}>
        <label style={{ display: 'block', fontSize: '0.85em', color: theme.text_secondary, marginBottom: '4px' }}>Beskrivning</label>
        <textarea
          name="description"
          value={form.description}
          onChange={onChange}
          placeholder="Kort beskrivning, t.ex. Behandling och träning"
          rows={2}
          style={{ width: '100%', padding: '7px 10px', border: `1px solid ${theme.card_border}`, borderRadius: theme.btn_radius, fontSize: '0.95em', boxSizing: 'border-box', resize: 'vertical' }}
        />
      </div>

      <div style={{ display: 'flex', gap: '12px', marginBottom: '12px', flexWrap: 'wrap' }}>
        <div style={{ flex: '1 1 120px' }}>
          <label style={{ display: 'block', fontSize: '0.85em', color: theme.text_secondary, marginBottom: '4px' }}>Längd (minuter)</label>
          <input
            name="duration"
            type="number"
            min="1"
            value={form.duration}
            onChange={onChange}
            style={{ width: '100%', padding: '7px 10px', border: `1px solid ${theme.card_border}`, borderRadius: theme.btn_radius, fontSize: '0.95em', boxSizing: 'border-box' }}
          />
        </div>
        <div style={{ flex: '1 1 120px' }}>
          <label style={{ display: 'block', fontSize: '0.85em', color: theme.text_secondary, marginBottom: '4px' }}>Pris</label>
          <input
            name="price"
            type="number"
            min="0"
            value={form.price}
            onChange={onChange}
            placeholder="0"
            style={{ width: '100%', padding: '7px 10px', border: `1px solid ${theme.card_border}`, borderRadius: theme.btn_radius, fontSize: '0.95em', boxSizing: 'border-box' }}
          />
        </div>
        <div style={{ flex: '1 1 90px' }}>
          <label style={{ display: 'block', fontSize: '0.85em', color: theme.text_secondary, marginBottom: '4px' }}>Valuta</label>
          <input
            name="currency"
            value={form.currency}
            onChange={onChange}
            style={{ width: '100%', padding: '7px 10px', border: `1px solid ${theme.card_border}`, borderRadius: theme.btn_radius, fontSize: '0.95em', boxSizing: 'border-box' }}
          />
        </div>
      </div>

      <div style={{ marginBottom: '12px' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '0.9em', color: '#444' }}>
          <input
            name="is_active"
            type="checkbox"
            checked={form.is_active}
            onChange={onChange}
          />
          Aktiv (visas för kunder vid bokning)
        </label>
      </div>

      <div style={{ borderTop: `1px solid ${theme.card_border}`, marginTop: '4px', paddingTop: '14px', marginBottom: '16px' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '0.9em', color: '#b45309', fontWeight: 500 }}>
          <input
            name="campaign_enabled"
            type="checkbox"
            checked={form.campaign_enabled}
            onChange={onChange}
          />
          Lägg till kampanj/rabatt
        </label>

        {form.campaign_enabled && (
          <div style={{ marginTop: '12px', background: STATUS_COLORS.warning_bg, border: '1px solid #fcd34d', borderRadius: theme.btn_radius, padding: '12px' }}>
            <div style={{ marginBottom: '10px' }}>
              <label style={{ display: 'block', fontSize: '0.85em', color: theme.text_secondary, marginBottom: '4px' }}>Kampanjtext</label>
              <input
                name="campaign_label"
                value={form.campaign_label}
                onChange={onChange}
                placeholder='t.ex. "Nystartserbjudande"'
                style={{ width: '100%', padding: '7px 10px', border: `1px solid ${theme.card_border}`, borderRadius: theme.btn_radius, fontSize: '0.95em', boxSizing: 'border-box' }}
              />
            </div>
            <div style={{ marginBottom: '10px' }}>
              <label style={{ display: 'block', fontSize: '0.85em', color: theme.text_secondary, marginBottom: '4px' }}>Kampanjpris *</label>
              <input
                name="campaign_price"
                type="number"
                min="0"
                value={form.campaign_price}
                onChange={onChange}
                required
                placeholder="0"
                style={{ width: '100%', padding: '7px 10px', border: `1px solid ${theme.card_border}`, borderRadius: theme.btn_radius, fontSize: '0.95em', boxSizing: 'border-box' }}
              />
            </div>
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
              <div style={{ flex: '1 1 140px' }}>
                <label style={{ display: 'block', fontSize: '0.85em', color: theme.text_secondary, marginBottom: '4px' }}>Startdatum</label>
                <input
                  name="campaign_start_date"
                  type="date"
                  value={form.campaign_start_date}
                  onChange={onChange}
                  style={{ width: '100%', padding: '7px 10px', border: `1px solid ${theme.card_border}`, borderRadius: theme.btn_radius, fontSize: '0.95em', boxSizing: 'border-box' }}
                />
              </div>
              <div style={{ flex: '1 1 140px' }}>
                <label style={{ display: 'block', fontSize: '0.85em', color: theme.text_secondary, marginBottom: '4px' }}>Slutdatum</label>
                <input
                  name="campaign_end_date"
                  type="date"
                  value={form.campaign_end_date}
                  onChange={onChange}
                  style={{ width: '100%', padding: '7px 10px', border: `1px solid ${theme.card_border}`, borderRadius: theme.btn_radius, fontSize: '0.95em', boxSizing: 'border-box' }}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      <div style={{ display: 'flex', gap: '10px' }}>
        <button type="submit" disabled={saving || !form.title.trim()} style={{ background: theme.accent, color: 'white', border: 'none', padding: '8px 18px', borderRadius: theme.btn_radius, cursor: 'pointer', fontWeight: 600 }}>
          {saving ? 'Sparar...' : submitLabel}
        </button>
        <button type="button" onClick={onCancel} style={{ background: 'none', color: NEUTRAL.text, border: `1px solid ${theme.card_border}`, padding: '8px 18px', borderRadius: theme.btn_radius, cursor: 'pointer' }}>
          Avbryt
        </button>
      </div>
    </form>
  );
}

function BookingServicesView({
  theme,
  services,
  addService,
  updateService,
  toggleService,
  deleteService,
}) {
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(EMPTY_FORM);
  const [saving, setSaving] = useState(false);

  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState(EMPTY_FORM);
  const [editSaving, setEditSaving] = useState(false);
  const [deletingServiceId, setDeletingServiceId] = useState(null);

  const handleOpen = () => {
    setForm(EMPTY_FORM);
    setShowForm(true);
    setEditingId(null);
  };

  const handleCancel = () => {
    setShowForm(false);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title.trim()) return;
    setSaving(true);
    await addService({
      title: form.title.trim(),
      description: form.description.trim() || null,
      duration: Number(form.duration),
      price: form.price !== '' ? Number(form.price) : null,
      currency: form.currency || 'SEK',
      is_active: form.is_active,
      campaign_enabled: form.campaign_enabled,
      campaign_label: form.campaign_enabled ? (form.campaign_label.trim() || null) : null,
      campaign_price: form.campaign_enabled && form.campaign_price !== '' ? Number(form.campaign_price) : null,
      campaign_start_date: form.campaign_enabled ? (form.campaign_start_date || null) : null,
      campaign_end_date: form.campaign_enabled ? (form.campaign_end_date || null) : null,
    });
    setSaving(false);
    setShowForm(false);
  };

  const handleEditOpen = (s) => {
    setEditingId(s.id);
    setEditForm({
      title: s.title || '',
      description: s.description || '',
      duration: s.duration ?? 60,
      price: s.price !== null && s.price !== undefined ? String(s.price) : '',
      currency: s.currency || 'SEK',
      is_active: s.is_active !== false,
      campaign_enabled: s.campaign_enabled || false,
      campaign_label: s.campaign_label || '',
      campaign_price: s.campaign_price !== null && s.campaign_price !== undefined ? String(s.campaign_price) : '',
      campaign_start_date: s.campaign_start_date || '',
      campaign_end_date: s.campaign_end_date || '',
    });
    setShowForm(false);
  };

  const handleEditCancel = () => {
    setEditingId(null);
  };

  const handleEditChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (!editForm.title.trim()) return;
    setEditSaving(true);
    await updateService(editingId, {
      title: editForm.title.trim(),
      description: editForm.description.trim() || null,
      duration: Number(editForm.duration),
      price: editForm.price !== '' ? Number(editForm.price) : null,
      currency: editForm.currency || 'SEK',
      is_active: editForm.is_active,
      campaign_enabled: editForm.campaign_enabled,
      campaign_label: editForm.campaign_enabled ? (editForm.campaign_label.trim() || null) : null,
      campaign_price: editForm.campaign_enabled && editForm.campaign_price !== '' ? Number(editForm.campaign_price) : null,
      campaign_start_date: editForm.campaign_enabled ? (editForm.campaign_start_date || null) : null,
      campaign_end_date: editForm.campaign_enabled ? (editForm.campaign_end_date || null) : null,
    });
    setEditSaving(false);
    setEditingId(null);
  };

  const [openId, setOpenId] = useState(null);
  const fmtDate = (d) => { if (!d) return '–'; const x = new Date(d + 'T12:00:00'); return `${x.getDate()} ${['jan','feb','mar','apr','maj','jun','jul','aug','sep','okt','nov','dec'][x.getMonth()]}`; };
  const chip = (bg, color, text) => <span style={{ background: bg, color, borderRadius: '999px', padding: '2px 8px', fontSize: '11px', fontWeight: '600', whiteSpace: 'nowrap' }}>{text}</span>;
  const link = { background: 'none', border: 'none', color: theme.accent_text, fontSize: '12px', fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit', padding: 0, whiteSpace: 'nowrap' };
  const linkMuted = { ...link, color: NEUTRAL.muted, fontWeight: '500' };

  return (
    <div style={{ background: theme.card_bg, border: `1px solid ${theme.card_border}`, borderRadius: theme.card_radius, boxShadow: theme.card_shadow, overflow: 'hidden' }}>
      <div style={{ padding: '14px 20px', borderBottom: `1px solid ${theme.card_border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '10px' }}>
          <h2 style={{ margin: 0, fontSize: '16px', fontWeight: '700', color: NEUTRAL.ink, fontFamily: 'var(--font-heading)' }}>Tjänster</h2>
          <span style={{ fontSize: '12px', color: NEUTRAL.muted }}>Det kunden väljer när hen bokar</span>
        </div>
        {!showForm && <button type="button" onClick={handleOpen} style={link}>+ Ny tjänst</button>}
      </div>

      {showForm && (
        <div style={{ padding: '16px 20px', borderBottom: `1px solid ${theme.card_border}` }}>
          <ServiceForm theme={theme} form={form} onChange={handleChange} onSubmit={handleSubmit} onCancel={handleCancel} saving={saving} heading="Ny tjänst" submitLabel="Spara tjänst" />
        </div>
      )}

      {services.length === 0 ? (
        <div style={{ margin: '12px', padding: '24px', textAlign: 'center', borderRadius: '10px', border: `1px dashed ${theme.card_border}`, fontSize: '12px', color: NEUTRAL.muted }}>Inga tjänster ännu · klicka på + Ny tjänst</div>
      ) : services.map((s, i) => {
        const campaignStatus = getCampaignStatus(s);
        const isOpen = openId === s.id;
        const last = i === services.length - 1;
        if (editingId === s.id) {
          return (
            <div key={s.id} style={{ padding: '16px 20px', borderBottom: last ? 'none' : `1px solid ${theme.card_border}` }}>
              <ServiceForm theme={theme} form={editForm} onChange={handleEditChange} onSubmit={handleEditSubmit} onCancel={handleEditCancel} saving={editSaving} heading={`Redigera: ${s.title}`} submitLabel="Spara ändringar" />
            </div>
          );
        }
        const priceText = s.price != null ? `${s.price} ${currencyLabel(s.currency)}` : null;
        const meta = [s.duration ? `${s.duration} min` : null, priceText].filter(Boolean).join(' · ');
        return (
          <div key={s.id} style={{ borderBottom: last ? 'none' : `1px solid ${theme.card_border}`, background: isOpen ? NEUTRAL.page : 'transparent', opacity: s.is_active ? 1 : 0.6 }}>
            <button type="button" onClick={() => setOpenId(isOpen ? null : s.id)} style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '14px', padding: '12px 20px', background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit', boxSizing: 'border-box' }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '14px', fontWeight: '600', color: NEUTRAL.ink, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.title}</div>
                <div style={{ fontSize: '12px', color: NEUTRAL.muted, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {meta}
                  {s.campaign_enabled && s.campaign_price != null && (
                    <span style={{ color: '#B45309' }}> · {campaignStatus === 'upcoming' ? 'kampanj från' : 'kampanj'} {s.campaign_price} {currencyLabel(s.currency)}{s.campaign_end_date ? ` t.o.m. ${fmtDate(s.campaign_end_date)}` : ''}{campaignStatus === 'expired' ? ' (avslutad)' : ''}</span>
                  )}
                </div>
              </div>
              {s.is_active ? chip(STATUS_COLORS.success_bg, '#15803D', 'Bokningsbar') : chip(STATUS_COLORS.neutral_bg, STATUS_COLORS.neutral, 'Pausad')}
              <span aria-hidden="true" style={{ fontSize: '12px', color: NEUTRAL.line }}>{isOpen ? '▴' : '▾'}</span>
            </button>
            {isOpen && (
              <div style={{ padding: '0 20px 12px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {s.description && <div style={{ fontSize: '13px', color: NEUTRAL.text, lineHeight: 1.5 }}>{s.description}</div>}
                {s.campaign_enabled && (
                  <div style={{ fontSize: '12px', color: NEUTRAL.muted }}>
                    Kampanj{s.campaign_label ? ` "${s.campaign_label}"` : ''}: {s.campaign_price != null ? `${s.campaign_price} ${currencyLabel(s.currency)}` : 'inget pris'} · {fmtDate(s.campaign_start_date)} – {fmtDate(s.campaign_end_date)}
                  </div>
                )}
                <div style={{ display: 'flex', gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
                  <button type="button" onClick={() => { handleEditOpen(s); setOpenId(null); }} style={link}>Redigera</button>
                  <button type="button" onClick={() => toggleService(s.id, s.is_active)} style={linkMuted}>{s.is_active ? 'Pausa' : 'Aktivera'}</button>
                  <span style={{ flex: 1 }} />
                  {deletingServiceId === s.id ? (
                    <>
                      <button type="button" onClick={() => { deleteService(s.id); setDeletingServiceId(null); }} style={{ background: STATUS_COLORS.error_bg, border: `1px solid ${STATUS_COLORS.error}`, color: '#B91C1C', padding: '5px 10px', borderRadius: theme.btn_radius, fontSize: '12px', fontWeight: '600', cursor: 'pointer', fontFamily: 'inherit' }}>Ja, ta bort</button>
                      <button type="button" onClick={() => setDeletingServiceId(null)} style={{ ...linkMuted }}>Avbryt</button>
                    </>
                  ) : (
                    <button type="button" onClick={() => setDeletingServiceId(s.id)} style={{ ...linkMuted, color: STATUS_COLORS.error }}>Ta bort</button>
                  )}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default BookingServicesView;
